var _rect, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWordpress(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    rx: 9,
    fill: "#21759B"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_100424_443022)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.85254 8.99991C3.85254 11.0373 5.03655 12.798 6.75345 13.6323L4.29817 6.90515C4.01257 7.54529 3.85254 8.2537 3.85254 8.99991Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.4745 8.74015C12.4745 8.10403 12.246 7.66349 12.0501 7.3206C11.7892 6.89661 11.5446 6.53756 11.5446 6.11357C11.5446 5.64042 11.9034 5.19998 12.4089 5.19998C12.4317 5.19998 12.4534 5.20282 12.4756 5.2041C11.5599 4.36514 10.3398 3.85291 8.9998 3.85291C7.20161 3.85291 5.61957 4.77551 4.69922 6.17293C4.81998 6.17655 4.93379 6.1791 5.03045 6.1791C5.56884 6.1791 6.40221 6.11377 6.40221 6.11377C6.67968 6.09741 6.71239 6.50495 6.43522 6.53776C6.43522 6.53776 6.15638 6.57057 5.84611 6.58682L7.7205 12.1621L8.84691 8.78383L8.04497 6.58663C7.7678 6.57037 7.50522 6.53756 7.50522 6.53756C7.22785 6.5213 7.26037 6.09722 7.53774 6.11357C7.53774 6.11357 8.38777 6.1789 8.89353 6.1789C9.43182 6.1789 10.2653 6.11357 10.2653 6.11357C10.543 6.09722 10.5756 6.50475 10.2983 6.53756C10.2983 6.53756 10.0189 6.57037 9.70918 6.58663L11.5693 12.1197L12.0827 10.4041C12.3052 9.69213 12.4745 9.18079 12.4745 8.74015Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.09023 9.45007L7.5459 13.9376C8.007 14.0732 8.49465 14.1473 8.99993 14.1473C9.59932 14.1473 10.1741 14.0437 10.7092 13.8555C10.6954 13.8335 10.6828 13.8101 10.6726 13.7846L9.09023 9.45007Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.5168 6.5304C13.539 6.69435 13.5515 6.87035 13.5515 7.05967C13.5515 7.58199 13.454 8.16914 13.1601 8.9033L11.5879 13.449C13.1181 12.5567 14.1474 10.8988 14.1474 8.99997C14.1475 8.10509 13.9189 7.26358 13.5168 6.5304Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.00005 3C5.69171 3 3 5.69151 3 8.99985C3 12.3086 5.69171 15 9.00005 15C12.3083 15 15.0004 12.3086 15.0004 8.99985C15.0003 5.69151 12.3083 3 9.00005 3ZM9.00005 14.725C5.84342 14.725 3.27512 12.1567 3.27512 8.99985C3.27512 5.84322 5.84332 3.27512 9.00005 3.27512C12.1566 3.27512 14.7247 5.84322 14.7247 8.99985C14.7247 12.1567 12.1566 14.725 9.00005 14.725Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_100424_443022"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 11.9997,
    height: 12,
    fill: "white",
    transform: "translate(3 3)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWordpress);
export default __webpack_public_path__ + "static/media/wordpress.99967a5515a21cce5403f2f0fbb6fa4c.svg";
export { ForwardRef as ReactComponent };